const sectionTitle = {
  fontSize: 24,
  fontWeight: 800,
  marginBottom: 10,
  paddingLeft: 8
};

const pricingGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
  gap: 24,
  marginTop: 2
};

export default function PricingSection() {
  return (
    <section style={{ marginBottom: 8 }}>
      <h2 style={sectionTitle}>Pricing</h2>

      <div style={pricingGrid}>
        <PricingCard
          title="Starter"
          price="$99 / month"
          description="For small operators testing online estimates"
          features={[
            "Up to 30 assessments / month",
            "Photo-based item identification",
            "Volume & item estimates",
            "Email notifications",
            "Basic branding"
          ]}
        />

        <PricingCard
          title="Professional"
          price="$199 / month"
          highlight
          description="For active junk removal businesses"
          features={[
            "Up to 100 assessments / month",
            "Priority processing",
            "Editable pricing rules",
            "Service-area filtering",
            "SMS + email lead delivery",
            "Fully branded experience"
          ]}
        />

        <PricingCard
          title="Growth"
          price="$349 / month"
          description="For multi-crew or high-volume operators"
          features={[
            "Up to 300 assessments / month",
            "Multi-location support",
            "Crew routing metadata",
            "CRM / dispatch export",
            "Advanced analytics"
          ]}
        />
      </div>
    </section>
  );
}

function PricingCard({ title, price, description, features, highlight }) {
  return (
    <div
      style={{
        paddingTop: 0,
        paddingLeft: 28,
        paddingRight: 28,
        paddingBottom: 10,
        borderRadius: 16,
        background: "#ffffff",
        border: highlight ? "2px solid #22c55e" : "1px solid #e5e7eb",
        boxShadow: "0 10px 20px rgba(0,0,0,0.04)"
      }}
    >
      <div
        style={{
          fontSize: 22,
          fontWeight: 700,
          paddingTop: 15,
          paddingBottom: 10
        }}
      >
        {title}
      </div>

      <div style={{ fontSize: 24, fontWeight: 600 }}>{price}</div>
      <p style={{ color: "#64748b" }}>{description}</p>

      <ul>
        {features.map((f, i) => (
          <li key={i}>{f}</li>
        ))}
      </ul>
    </div>
  );
}
